export default [
  {
    path: '/app/bank-accounts',
    name: 'BankAccounts',
    component: () => import('@/views/Admin/Bank_accounts/Index.vue'),
    meta: {
      pageTitle: 'Banka Hesapları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_BANK_ACCOUNTS',
      action: 'read',
    },
  },
  {
    path: '/app/bank-accounts/add',
    name: 'BankAccountAdd',
    component: () => import('@/views/Admin/Bank_accounts/Add.vue'),
    meta: {
      pageTitle: 'Banka Hesapları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/bank-accounts',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_BANK_ACCOUNTS',
      action: 'read',
    },
  },
  {
    path: '/app/bank-accounts/edit/:id',
    name: 'BankAccountEdit',
    component: () => import('@/views/Admin/Bank_accounts/Edit.vue'),
    meta: {
      pageTitle: 'Banka Hesapları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/bank-accounts',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_BANK_ACCOUNTS',
      action: 'read',
    },
  },
]
